// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-nav__icon {
  padding-right: 5px;
}

.navbar-nav .dropdown-menu--open {
  display: block;
}

.main-header .dropdown-menu > .divider {
  background: #eee !important;
}

.main-header .navbar .nav > li > a > .label {
  z-index: 1;
  min-width: 13px;
  padding: 2px;
  top: 7px;
}

.header-dropdown__content-item {
  border-bottom: 0;
  flex-direction: row;
  flex-shrink: 0;
  padding: 7px 10px;
  display: flex;
}

.header-dropdown__job-icon-wrapper {
  margin-right: 6px;
}

.header-dropdown__content-header {
  background: #f4f4f4;
  border-top: 1px solid #f5f5f5;
  border-bottom: 0;
  flex-shrink: 0;
  padding: 7px 10px;
  font-weight: 600;
  color: #000 !important;
}

.header-dropdown__content-header:first-of-type {
  border-top: 0;
}

.header-dropdown__content-header.header {
  color: #000 !important;
}

.header-dropdown__content-header--border {
  border-bottom: 1px solid #f5f5f5;
}

.header-dropdown__content-header--with-button {
  padding: 6px 10px;
}

.header-dropdown__content-detail {
  color: gray;
  justify-content: space-between;
  display: flex;
}

.header-dropdown__action-wraper {
  text-align: right;
  flex: 1;
  padding-left: 10px;
}

.header__support-menu-link {
  color: #777 !important;
}

.header__support-menu-link:hover {
  color: #333 !important;
  background: #e1e3e9 !important;
}

.header__support-menu-anchor {
  color: #777 !important;
}

.header__support-menu-anchor:hover {
  color: #333 !important;
  background: #e1e3e9 !important;
}

.header__new-update {
  background: var(--success);
  color: #fff;
  float: right;
  text-align: center;
  display: block;
}

.header__new-update:hover, .header__new-update:active, .header__new-update:focus {
  color: #fff;
  background: #9bbb59cc;
}

.header__navbar-nav {
  flex: none;
}

@media (width >= 768px) {
  .header__navbar-nav {
    flex: 0;
  }
}

.header__license-device-limit {
  background: var(--warning);
  color: #fff;
  float: right;
  text-align: center;
  display: block;
}

.header__license-device-limit:hover, .header__license-device-limit:active, .header__license-device-limit:focus {
  color: #fff;
  background: #ffc000cc;
}

.header__anchor {
  color: #fff;
  padding: 8px 12px;
  display: inline-block;
}

.header__anchor:hover, .header__anchor:active, .header__anchor:focus {
  color: #fff;
}

@media (width >= 992px) {
  .header__anchor {
    padding: 8px 12px;
  }
}

.header__box-link {
  color: #fff;
  padding: 8px 12px;
  display: inline-block;
}

.header__box-link:hover, .header__box-link:active, .header__box-link:focus {
  color: #fff;
}

@media (width >= 992px) {
  .header__box-link {
    padding: 8px 12px;
  }
}

.header__dropdown-toggle {
  text-align: center;
  padding-left: 7px !important;
  padding-right: 7px !important;
}

@media (width >= 992px) {
  .header__dropdown-toggle {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
}

.header-dropdown__dropdown-menu {
  width: 400px;
  padding-top: 0;
  padding-bottom: 0;
}

.header-dropdown__dropdown-li {
  position: static !important;
}

.header-notifications__bell-wrapper {
  text-align: center;
  min-width: 13px;
  padding: 2px;
  font-size: 9px;
  line-height: .9;
  position: absolute;
  top: 1px;
  right: 1px;
}

.header__expired-box {
  background: var(--info);
  color: #fff;
  float: right;
  text-align: center;
  line-height: 20px;
  display: none;
}

.header__expired-box:hover {
  background: var(--info);
  color: #fff;
}

.header__expired-box:active, .header__expired-box:focus {
  color: #fff;
  background: #4f81bdcc;
}

@media (width >= 992px) {
  .header__expired-box {
    display: block;
  }
}

.header__expired-box--expired {
  background: var(--danger);
}

.header__expired-box--expired:hover {
  background: #ff3232cc;
}

.header__expired-box--expired:active, .header__expired-box--expired:focus {
  background: var(--danger);
}

.header__expired-box--desktop-small {
  display: block;
}

@media (width >= 992px) {
  .header__expired-box--desktop-small {
    display: none;
  }
}

.header__error-box {
  background: var(--danger);
  color: #fff;
  float: right;
  text-align: center;
  line-height: 20px;
  display: none;
}

.header__error-box:hover {
  color: #fff;
  background: #ff3232cc;
}

.header__error-box:active, .header__error-box:focus {
  background: var(--danger);
  color: #fff;
}

@media (width >= 992px) {
  .header__error-box {
    display: block;
  }
}

.header__error-box--desktop-small {
  display: block;
}

@media (width >= 992px) {
  .header__error-box--desktop-small {
    display: none;
  }
}

.header-job-management__animation-icon {
  z-index: 10;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;
  position: absolute;
  inset: 0;
}

.header-job-management__animation-content {
  font-size: 1.5em;
}

.header__logo-version {
  margin-left: var(--base-sizes-2);
  margin-bottom: var(--base-sizes-1px);
  font-size: .875rem;
  line-height: 1.25rem;
  font-weight: var(--base-font-weight-semibold);
  --tw-text-opacity: 1;
  color: rgb(var(--base-colors-white-white100) / var(--tw-text-opacity));
  line-height: 1;
}

.header__user-image-top {
  margin-left: 5px !important;
  margin-right: 5px !important;
}

.skin-purple .main-header .navbar, .skin-purple .main-header .logo {
  --tw-bg-opacity: 1;
  background-color: rgb(38 65 131 / var(--tw-bg-opacity));
}

.skin-purple .main-header .logo {
  flex-direction: row;
  align-items: center;
  display: flex;
}

.skin-purple .main-header .logo:hover, .skin-purple .main-header .navbar .nav > li > a:hover, .skin-purple .main-header .navbar .nav > li > a:active, .skin-purple .main-header .navbar .nav > li > a:focus, .skin-purple .main-header .navbar .nav .open > a, .skin-purple .main-header .navbar .nav .open > a:hover, .skin-purple .main-header .navbar .nav .open > a:focus, .skin-purple .main-header .navbar .nav > .active > a {
  --tw-bg-opacity: 1;
  background-color: rgb(27 45 91 / var(--tw-bg-opacity));
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/containers/App/Header/styles/Header.css","webpack://./services/frontend/app/containers/App/Header/styles/Header.css"],"names":[],"mappings":"AADA;ECEE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,OAAO;EACT;AACF;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;AACF;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,oBAAoB;EACpB,6CAA6C;EAC7C,oBAAoB;EACpB,sEAAsE;EACtE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD","sourcesContent":[".navbar-nav__icon {\n  padding-right: 5px;\n}\n\n.navbar-nav .dropdown-menu--open {\n  display: block;\n}\n\n.main-header .dropdown-menu > .divider {\n  background: #eee !important;\n}\n\n.main-header .navbar .nav > li > a > .label {\n  min-width: 13px;\n  z-index: 1;\n  padding: 2px;\n  top: 7px;\n}\n\n.header-dropdown__content-item {\n  border-bottom: 0;\n  display: flex;\n  flex-direction: row;\n  flex-shrink: 0;\n  padding: 7px 10px;\n}\n\n.header-dropdown__job-icon-wrapper {\n  margin-right: 6px;\n}\n\n.header-dropdown__content-header {\n  background: #f4f4f4;\n  border-bottom: 0;\n  border-top: 1px solid #f5f5f5;\n  color: #000 !important;\n  flex-shrink: 0;\n  font-weight: 600;\n  padding: 7px 10px;\n}\n\n.header-dropdown__content-header:first-of-type {\n    border-top: 0;\n  }\n\n.header-dropdown__content-header.header {\n    color: #000 !important;\n  }\n\n.header-dropdown__content-header--border {\n  border-bottom: 1px solid #f5f5f5;\n}\n\n.header-dropdown__content-header--with-button {\n  padding: 6px 10px;\n}\n\n.header-dropdown__content-detail {\n  color: HSL(0deg, 0%, 50%);\n  display: flex;\n  justify-content: space-between;\n}\n\n.header-dropdown__action-wraper {\n  flex: 1;\n  padding-left: 10px;\n  text-align: right;\n}\n\n.header__support-menu-link {\n  color: #777 !important;\n}\n\n.header__support-menu-link:hover {\n    background: #e1e3e9 !important;\n    color: #333 !important;\n  }\n\n.header__support-menu-anchor {\n  color: #777 !important;\n}\n\n.header__support-menu-anchor:hover {\n    background: #e1e3e9 !important;\n    color: #333 !important;\n  }\n\n.header__new-update {\n  display: block;\n  background: var(--success);\n  color: #fff;\n  float: right;\n  text-align: center;\n}\n\n.header__new-update:hover,\n  .header__new-update:active,\n  .header__new-update:focus {\n    background: rgba(155, 187, 89, 0.8);\n    color: #fff;\n  }\n\n.header__navbar-nav {\n  flex: 0 0 auto;\n}\n\n@media (min-width: 768px) {\n\n.header__navbar-nav {\n    flex: 0\n}\n  }\n\n.header__license-device-limit {\n  display: block;\n  background: var(--warning);\n  color: #fff;\n  float: right;\n  text-align: center;\n}\n\n.header__license-device-limit:hover,\n  .header__license-device-limit:active,\n  .header__license-device-limit:focus {\n    background: rgba(255, 192, 0, 0.8);\n    color: #fff;\n  }\n\n.header__anchor {\n  color: #fff;\n  display: inline-block;\n  padding: 8px 12px;\n}\n\n.header__anchor:hover {\n    color: #fff;\n  }\n\n.header__anchor:active,\n  .header__anchor:focus {\n    color: #fff;\n  }\n\n@media (min-width: 992px) {\n\n.header__anchor {\n    padding: 8px 12px\n}\n  }\n\n.header__box-link {\n  color: #fff;\n  display: inline-block;\n  padding: 8px 12px;\n}\n\n.header__box-link:hover {\n    color: #fff;\n  }\n\n.header__box-link:active,\n  .header__box-link:focus {\n    color: #fff;\n  }\n\n@media (min-width: 992px) {\n\n.header__box-link {\n    padding: 8px 12px\n}\n  }\n\n.header__dropdown-toggle {\n  padding-left: 7px !important;\n  padding-right: 7px !important;\n  text-align: center;\n}\n\n@media (min-width: 992px) {\n\n.header__dropdown-toggle {\n    padding-left: 12px !important;\n    padding-right: 12px !important\n}\n  }\n\n.header-dropdown__dropdown-menu {\n  padding-top: 0;\n  padding-bottom: 0;\n  width: 400px;\n}\n\n.header-dropdown__dropdown-li {\n  position: static !important;\n}\n\n.header-notifications__bell-wrapper {\n  font-size: 9px;\n  line-height: 0.9;\n  padding: 2px;\n  position: absolute;\n  right: 1px;\n  text-align: center;\n  top: 1px;\n  min-width: 13px;\n}\n\n.header__expired-box {\n  background: var(--info);\n  color: #fff;\n  display: none;\n  float: right;\n  line-height: 20px;\n  text-align: center;\n}\n\n.header__expired-box:hover {\n    background: var(--info);\n    color: #fff;\n  }\n\n.header__expired-box:active,\n  .header__expired-box:focus {\n    background: rgba(79, 129, 189, 0.8);\n    color: #fff;\n  }\n\n@media (min-width: 992px) {\n\n.header__expired-box {\n    display: block\n}\n  }\n\n.header__expired-box--expired {\n  background: var(--danger);\n}\n\n.header__expired-box--expired:hover {\n    background: rgba(255, 50, 50, 0.8);\n  }\n\n.header__expired-box--expired:active,\n  .header__expired-box--expired:focus {\n    background: var(--danger);\n  }\n\n.header__expired-box--desktop-small {\n  display: block;\n}\n\n@media (min-width: 992px) {\n\n.header__expired-box--desktop-small {\n    display: none\n}\n  }\n\n.header__error-box {\n  background: var(--danger);\n  color: #fff;\n  display: none;\n  float: right;\n  line-height: 20px;\n  text-align: center;\n}\n\n.header__error-box:hover {\n    background: rgba(255, 50, 50, 0.8);\n    color: #fff;\n  }\n\n.header__error-box:active,\n  .header__error-box:focus {\n    background: var(--danger);\n    color: #fff;\n  }\n\n@media (min-width: 992px) {\n\n.header__error-box {\n    display: block\n}\n  }\n\n.header__error-box--desktop-small {\n  display: block;\n}\n\n@media (min-width: 992px) {\n\n.header__error-box--desktop-small {\n    display: none\n}\n  }\n\n.header-job-management__animation-icon {\n  align-items: center;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 10;\n}\n\n.header-job-management__animation-content {\n  font-size: 1.5em;\n}\n\n.header__logo-version {\n  margin-left: var(--base-sizes-2);\n  margin-bottom: var(--base-sizes-1px);\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: var(--base-font-weight-semibold);\n  line-height: 1;\n  --tw-text-opacity: 1;\n  color: rgb(var(--base-colors-white-white100) / var(--tw-text-opacity));\n}\n\n.header__user-image-top {\n  margin-right: 5px !important;\n  margin-left: 5px !important;\n}\n\n.skin-purple .main-header .navbar,\n.skin-purple .main-header .logo {\n  --tw-bg-opacity: 1;\n  background-color: rgb(38 65 131 / var(--tw-bg-opacity));\n}\n\n.skin-purple .main-header .logo {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.skin-purple .main-header .logo:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(27 45 91 / var(--tw-bg-opacity));\n}\n\n.skin-purple .main-header .navbar .nav > li > a:hover,\n.skin-purple .main-header .navbar .nav > li > a:active,\n.skin-purple .main-header .navbar .nav > li > a:focus,\n.skin-purple .main-header .navbar .nav .open > a,\n.skin-purple .main-header .navbar .nav .open > a:hover,\n.skin-purple .main-header .navbar .nav .open > a:focus,\n.skin-purple .main-header .navbar .nav > .active > a {\n  --tw-bg-opacity: 1;\n  background-color: rgb(27 45 91 / var(--tw-bg-opacity));\n}\n",".navbar-nav__icon {\n  padding-right: 5px;\n}\n\n.navbar-nav .dropdown-menu--open {\n  display: block;\n}\n\n.main-header .dropdown-menu > .divider {\n  background: #eee !important;\n}\n\n.main-header .navbar .nav > li > a > .label {\n  z-index: 1;\n  min-width: 13px;\n  padding: 2px;\n  top: 7px;\n}\n\n.header-dropdown__content-item {\n  border-bottom: 0;\n  flex-direction: row;\n  flex-shrink: 0;\n  padding: 7px 10px;\n  display: flex;\n}\n\n.header-dropdown__job-icon-wrapper {\n  margin-right: 6px;\n}\n\n.header-dropdown__content-header {\n  background: #f4f4f4;\n  border-top: 1px solid #f5f5f5;\n  border-bottom: 0;\n  flex-shrink: 0;\n  padding: 7px 10px;\n  font-weight: 600;\n  color: #000 !important;\n}\n\n.header-dropdown__content-header:first-of-type {\n  border-top: 0;\n}\n\n.header-dropdown__content-header.header {\n  color: #000 !important;\n}\n\n.header-dropdown__content-header--border {\n  border-bottom: 1px solid #f5f5f5;\n}\n\n.header-dropdown__content-header--with-button {\n  padding: 6px 10px;\n}\n\n.header-dropdown__content-detail {\n  color: gray;\n  justify-content: space-between;\n  display: flex;\n}\n\n.header-dropdown__action-wraper {\n  text-align: right;\n  flex: 1;\n  padding-left: 10px;\n}\n\n.header__support-menu-link {\n  color: #777 !important;\n}\n\n.header__support-menu-link:hover {\n  color: #333 !important;\n  background: #e1e3e9 !important;\n}\n\n.header__support-menu-anchor {\n  color: #777 !important;\n}\n\n.header__support-menu-anchor:hover {\n  color: #333 !important;\n  background: #e1e3e9 !important;\n}\n\n.header__new-update {\n  background: var(--success);\n  color: #fff;\n  float: right;\n  text-align: center;\n  display: block;\n}\n\n.header__new-update:hover, .header__new-update:active, .header__new-update:focus {\n  color: #fff;\n  background: #9bbb59cc;\n}\n\n.header__navbar-nav {\n  flex: none;\n}\n\n@media (width >= 768px) {\n  .header__navbar-nav {\n    flex: 0;\n  }\n}\n\n.header__license-device-limit {\n  background: var(--warning);\n  color: #fff;\n  float: right;\n  text-align: center;\n  display: block;\n}\n\n.header__license-device-limit:hover, .header__license-device-limit:active, .header__license-device-limit:focus {\n  color: #fff;\n  background: #ffc000cc;\n}\n\n.header__anchor {\n  color: #fff;\n  padding: 8px 12px;\n  display: inline-block;\n}\n\n.header__anchor:hover, .header__anchor:active, .header__anchor:focus {\n  color: #fff;\n}\n\n@media (width >= 992px) {\n  .header__anchor {\n    padding: 8px 12px;\n  }\n}\n\n.header__box-link {\n  color: #fff;\n  padding: 8px 12px;\n  display: inline-block;\n}\n\n.header__box-link:hover, .header__box-link:active, .header__box-link:focus {\n  color: #fff;\n}\n\n@media (width >= 992px) {\n  .header__box-link {\n    padding: 8px 12px;\n  }\n}\n\n.header__dropdown-toggle {\n  text-align: center;\n  padding-left: 7px !important;\n  padding-right: 7px !important;\n}\n\n@media (width >= 992px) {\n  .header__dropdown-toggle {\n    padding-left: 12px !important;\n    padding-right: 12px !important;\n  }\n}\n\n.header-dropdown__dropdown-menu {\n  width: 400px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.header-dropdown__dropdown-li {\n  position: static !important;\n}\n\n.header-notifications__bell-wrapper {\n  text-align: center;\n  min-width: 13px;\n  padding: 2px;\n  font-size: 9px;\n  line-height: .9;\n  position: absolute;\n  top: 1px;\n  right: 1px;\n}\n\n.header__expired-box {\n  background: var(--info);\n  color: #fff;\n  float: right;\n  text-align: center;\n  line-height: 20px;\n  display: none;\n}\n\n.header__expired-box:hover {\n  background: var(--info);\n  color: #fff;\n}\n\n.header__expired-box:active, .header__expired-box:focus {\n  color: #fff;\n  background: #4f81bdcc;\n}\n\n@media (width >= 992px) {\n  .header__expired-box {\n    display: block;\n  }\n}\n\n.header__expired-box--expired {\n  background: var(--danger);\n}\n\n.header__expired-box--expired:hover {\n  background: #ff3232cc;\n}\n\n.header__expired-box--expired:active, .header__expired-box--expired:focus {\n  background: var(--danger);\n}\n\n.header__expired-box--desktop-small {\n  display: block;\n}\n\n@media (width >= 992px) {\n  .header__expired-box--desktop-small {\n    display: none;\n  }\n}\n\n.header__error-box {\n  background: var(--danger);\n  color: #fff;\n  float: right;\n  text-align: center;\n  line-height: 20px;\n  display: none;\n}\n\n.header__error-box:hover {\n  color: #fff;\n  background: #ff3232cc;\n}\n\n.header__error-box:active, .header__error-box:focus {\n  background: var(--danger);\n  color: #fff;\n}\n\n@media (width >= 992px) {\n  .header__error-box {\n    display: block;\n  }\n}\n\n.header__error-box--desktop-small {\n  display: block;\n}\n\n@media (width >= 992px) {\n  .header__error-box--desktop-small {\n    display: none;\n  }\n}\n\n.header-job-management__animation-icon {\n  z-index: 10;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  position: absolute;\n  inset: 0;\n}\n\n.header-job-management__animation-content {\n  font-size: 1.5em;\n}\n\n.header__logo-version {\n  margin-left: var(--base-sizes-2);\n  margin-bottom: var(--base-sizes-1px);\n  font-size: .875rem;\n  line-height: 1.25rem;\n  font-weight: var(--base-font-weight-semibold);\n  --tw-text-opacity: 1;\n  color: rgb(var(--base-colors-white-white100) / var(--tw-text-opacity));\n  line-height: 1;\n}\n\n.header__user-image-top {\n  margin-left: 5px !important;\n  margin-right: 5px !important;\n}\n\n.skin-purple .main-header .navbar, .skin-purple .main-header .logo {\n  --tw-bg-opacity: 1;\n  background-color: rgb(38 65 131 / var(--tw-bg-opacity));\n}\n\n.skin-purple .main-header .logo {\n  flex-direction: row;\n  align-items: center;\n  display: flex;\n}\n\n.skin-purple .main-header .logo:hover, .skin-purple .main-header .navbar .nav > li > a:hover, .skin-purple .main-header .navbar .nav > li > a:active, .skin-purple .main-header .navbar .nav > li > a:focus, .skin-purple .main-header .navbar .nav .open > a, .skin-purple .main-header .navbar .nav .open > a:hover, .skin-purple .main-header .navbar .nav .open > a:focus, .skin-purple .main-header .navbar .nav > .active > a {\n  --tw-bg-opacity: 1;\n  background-color: rgb(27 45 91 / var(--tw-bg-opacity));\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
